import { extend, sorted } from './helper.esm.js';
import MatchDictionary from './matching/Dictionary.esm.js';
import MatchL33t from './matching/L33t.esm.js';
import MatchDictionaryReverse from './matching/DictionaryReverse.esm.js';
import MatchSpatial from './matching/Spatial.esm.js';
import MatchRepeat from './matching/Repeat.esm.js';
import MatchSequence from './matching/Sequence.esm.js';
import MatchRegex from './matching/Regex.esm.js';
import MatchDate from './matching/Date.esm.js';

/*
 * -------------------------------------------------------------------------------
 *  Omnimatch combine matchers ---------------------------------------------------------------
 * -------------------------------------------------------------------------------
 */

class Matching {
  constructor() {
    this.matchers = [MatchDictionary, MatchDictionaryReverse, MatchL33t, MatchSpatial, MatchRepeat, MatchSequence, MatchRegex, MatchDate];
    this.options = {};
  }

  match(password) {
    const matches = [];
    this.matchers.forEach(Entry => {
      const matcher = new Entry();
      extend(matches, matcher.match({
        password,
        omniMatch: this
      }));
    });
    return sorted(matches);
  }

}

export default Matching;
//# sourceMappingURL=Matching.esm.js.map
